import Entity from '../../utilities/entity';
import Training from '../training';

class TrainingSubscription extends Entity {
  // training() {
  //     return this.hasOne(Training);
  // }
}

export default new TrainingSubscription();
